export const reviews = [
  {
    id: 1,
    text:
      "Renting out my home through this website has been a wonderful experience. The user-friendly interface and the reliable platform make it easy for me to list my property. The booking system works flawlessly, and I always receive timely notifications when a reservation is made. Communication with guests is smooth, allowing me to offer a personal and hassle-free service. Thanks to this website, I am confident that my home is in good hands, and the positive feedback from my guests reaffirms this every time!",
    author: "Rick Terp",
    location: "Host from the Netherlands",
    img: "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?auto=format&fit=crop&w=200&h=200&q=80",
  },
  {
    id: 2,
    text:
      "Listing my apartment on this platform has been such a smooth experience. The dashboard makes it easy to manage bookings and stay on top of everything, and guests always mention how easy the check-in process was. I've had a steady stream of bookings since day one.",
    author: "Melissa Steenberk",
    location: "Host from the Netherlands",
    img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&h=200&q=80",
  },
  {
    id: 3,
    text:
      "As a host managing several vacation properties, this platform has completely simplified how I run things. The centralized dashboard, secure payments, and responsive support team mean I can focus on giving guests a great stay instead of chasing admin. Highly recommend for any serious host.",
    author: "James Heck",
    location: "Host with multiple properties",
    img: "https://images.unsplash.com/photo-1527980965255-d3b416303d12?auto=format&fit=crop&w=200&h=200&q=80",
  },
  {
    id: 4,
    text:
      "I recently hosted my website with Domits in the UK, and the experience has been exceptional. The platform is user-friendly, allowing for quick setup and seamless integration. Speed and reliability are top-notch, with minimal downtime, ensuring my site is always accessible. The customer support team is also extremely helpful, addressing any issues promptly and professionally. If you're looking for a solid hosting solution in the UK, this service offers great performance, security, and value for money. Highly recommended for anyone serious about a stable online presence!",
    author: "Jaimee Becker",
    location: "Host from UK",
    img: "https://images.unsplash.com/photo-1552053831-71594a27632d?auto=format&fit=crop&w=200&h=200&q=80",
  },
  {
    id: 5,
    text:
      "Reliable and Efficient Hosting from Germany I recently switched to a hosting provider based in Germany, and it’s been an excellent decision. The platform is fast and stable, offering great performance with little to no downtime. The setup process was straightforward, and the service provides excellent security features, which is especially important for websites dealing with sensitive data. The German-based servers have shown impressive speed for both local and international visitors, making it a fantastic choice for businesses or personal websites looking for reliability and performance. Highly recommended for those seeking a strong hosting solution from Germany!",
    author: "Maurice von Dorn",
    location: "Host from Germany",
    img: "https://randomuser.me/api/portraits/men/75.jpg",
  },
  {
    id: 6,
    text:
      "As the owner of Amode, I’ve had the opportunity to host several websites on various platforms, and the service we provide has consistently exceeded expectations. Our hosting solutions are designed to offer a seamless, high-performance experience with reliable uptime, top-notch security features, and a user-friendly interface. Whether you're running a small business or a larger operation, our infrastructure is built to scale efficiently and ensure your site is always performing at its best. At Amode, we prioritize customer satisfaction, and our support team is available around the clock to help with any issues that may arise. We take pride in offering hosting that’s as robust as it is reliable, making us a trusted choice for clients worldwide.",
    author: "Laisa Feldt",
    location: "Owner at Amode",
    img: "https://randomuser.me/api/portraits/women/65.jpg",
  },
];


